import { normalizeSearchSource } from './search-source.ts';

export function allowsWorkspaceTrack(track: { sourceType: string }, mode: string, webdavInLocal = true) {
  return mode === 'all' || (mode === 'online' ? track.sourceType === 'online' : track.sourceType === 'local' || webdavInLocal && track.sourceType === 'webdav');
}

export function workspaceSearchSource(appearance: string, mode: string, source: string) {
  const selected = normalizeSearchSource(source);
  if (appearance !== 'salt' && appearance !== 'apple') return selected;
  if (mode === 'local') return 'local';
  return mode === 'online' && selected === 'all' ? 'network' : selected;
}
